import type { ApiClient } from "@/lib/api";
import type { UserSourceUpdateRequest } from "../types";

export const updateUserSource = async ({
  client,
  userSourceId,
  payload,
}: {
  client: ApiClient;
  userSourceId: string;
  payload: UserSourceUpdateRequest;
}) => {
  const { data } = await client.patch(
    `/user_sources/${encodeURIComponent(userSourceId)}`,
    payload
  );
  return data;
};
